import classNames from 'classnames'

import Button from '../Button'

import * as styles from './Contained.module.css'

function Contained({
  className,
  isActive,
  isGrey,
  isLight,
  isSkeleton,
  ...restProps
}) {
  const buttonClassName = classNames(
    styles.contained,
    { [styles.basic]: !isLight && !isGrey },
    { [styles.light]: isLight },
    { [styles.grey]: isGrey },
    { [styles.active]: isActive },
    { [styles.skeleton]: isSkeleton },
    className
  )

  return (
    <Button
      {...restProps}
      className={buttonClassName}
      isActive={isActive}
      isSkeleton={isSkeleton}
    />
  )
}

export default Contained
